import { A, B, Button, Checkbox, Div, Em, Label, reactive, H2, H3, Span, Item, P } from 'alkali'
import { Chat } from 'integrations/intercom'
import { FilterArrows, QuestionArrow, FilterArrow } from 'components/entry/Arrows'
import { get, post, patch, put} from '../../tools/request'
import { track } from 'components/tracking/track'
import { readonlyMode, faqOrReadOnly } from 'model/SearchQuery'
import AppSettingsOptions from '../navbar/AppSettingsOptions'
import app from '../../app/app'
import './Explanation.scss'
import Icon from '../Icon'
import * as viewAbstract from 'icons/view-1.svg'
import * as editExtract from 'icons/pencil-2.svg'
import * as addExtract from 'icons/add-bold.svg'
import * as sortIcon from 'icons/data-transfer-vertical.svg'
import * as helpIcon from 'icons/question-circle.svg'
import * as positiveDirectionalityIcon from 'icons/monitor-heart-rate-up.svg'
import { activeTab } from 'components/entry/AvailableQuestionsPane'
import { characteristicInput } from 'components/filter/HasFilter'
import { StudyList } from 'components/studies/StudyList'
let buildQuestion = document.querySelector('.ask-question')
let blanket = new Div('.blanket', {})

export const showingExplanation = reactive().to(
	() => +localStorage.getItem('explanation') || 0,
	(explanationIndex) => localStorage.setItem('explanation', explanationIndex))
class Explanation extends Div('.welcome-explanation') {
	created(properties) {
		properties.content = [...properties.content]
		properties.display = showingExplanation.to(explanation => explanation == properties.index)
	}
}

export const QuestionExplanation = Explanation.with(
	'.search-explanation',
	{
		attached() {
			let input = characteristicInput.querySelector('.tt-input')
			//focus on conditions input on entry page unless in study list page
			if (document.body.classList.contains('ask-question') && this.searchBar) {
				input.focus()
			} else this.searchBar ? this.searchBar.focus() : null

			//hightlight search bar when user in in entry tour
			if (!this.searchBar) buildQuestion.classList.add('search')
			//esc key close
			document.addEventListener('keydown', function (e) {
				if (e.keyCode == 27) {
					if (document.body.classList.contains('ask-question') && this.searchBar) {
						input.focus()
						buildQuestion.classList.add('search')
					} else this.searchBar ? this.searchBar.focus() : null
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					removeContents()
					return
				}
			})

			const node = document.querySelector('.question-bar')
			node.addEventListener('keyup', function (event) {
				if (event.key === 'Enter') {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					removeContents()
				}
			})

			let close = A('.close', [' '], {
				onclick(event) {
					//focus on characteristics input after closing dialog on entry page
					if (document.body.classList.contains('ask-question') && this.searchBar) {
						input.focus()
						buildQuestion.classList.remove('search')
					} else this.searchBar ? this.searchBar.focus() : null
					quitAutoPromptTourNoUser('dashboardTour')
					quitAutoPromptTour('Dashboard')
					removeContents()
					return
				},
			})
			// this.append(close({ searchBar: this.searchBar }))
		},
	},
	[
		Div('.top-container', [
			Div('.header', [H2('Enter a Query'),A('.close', [' '], {
				onclick() {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					removeContents()
					if (document.querySelector('.ask-question'))
						document.querySelector('.ask-question').classList.remove('search')
					return
				},
			}),]),
			Div('.explanatory-text', [
				P('The search bar shows you the current research question you are searching for. If you would like to directly edit the question, you must enabled natural language questions in the app settings, see:'),
				A('.secondary', {
					content: 'App Settings',
					onclick: () => new AppSettingsOptions({ highlightQuestion: true }).show(),
				}),
				P([Span('.strong', ['Reminder: ']), P('DocAnalytics is currently optimized to answer '), Span('.italicize', ['safety']), Span(' and '), Span('.italicize', ['efficacy ']), Span('questions for therapies, using existing question structures and templates.')]),
			]),
			]),
		Div('.bottom-container.flex-end', [
			Button('.back2.primary', ['Back to Welcome Dialog'], {
				onclick() {
					buildQuestion.classList.remove('search')
					removeContents()
					showingExplanation.put(0)
					event.stopPropagation()
					event.preventDefault()
				},
			}),
			QuestionArrow
		])
	]
)

export const FilterExplanation = Explanation.with('.characteristics-explanation', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('dashboardStatisticsTour')
				quitAutoPromptTour('DashboardStatistics')
				buildQuestion.className = 'ask-question'
				removeContents()
				document.querySelectorAll('.filter-search').forEach(item => {item.className = 'filter-search'})
				return
			}
		})
		buildQuestion.classList.add('characteristics')
		document.querySelector('.explanatory-text').innerHTML = 'Select or enter the appropriate <strong>condition</strong>, <strong>treatment</strong>, and/or <strong>outcome</strong> of interest. <br><br> As you fill out the PICO form, DocAnalytics will update the suggestions with relevant terms based on your selections.'
	}
}, [
        Div('.top-container', [
		Div('.header', [H2('Build a Question'), 
		A('.close', [' '], {
			onclick() {
				quitAutoPromptTourNoUser('dashboardStatisticsTour')
				quitAutoPromptTour('DashboardStatistics')
				buildQuestion.className = 'ask-question'
				removeContents()
				document.querySelectorAll('.filter-search').forEach(item => {item.className = 'filter-search'})
				return
			}
		}),
	]),
		Div('.explanatory-text', ['']),
        ]),
		Div('.bottom-container', [
			Button('.back.secondary', ['Back'], {
				onclick() {
					buildQuestion.classList.replace('characteristics-step-two', 'characteristics')
					document.querySelector('.explanatory-text').innerHTML = 'Start your search by selecting or entering the appropriate <strong>Condition</strong>, <strong>Treatment</strong>, and/or <strong>Outcome</strong> of interest.'
				}
			}),
			Button('.back2.primary', ['Back to welcome dialog'], {
				onclick() {
					buildQuestion.className = 'ask-question'
					removeContents()
					showingExplanation.put(0)
					event.stopPropagation()
					event.preventDefault()
				}
			}),
			Button('.learn.primary', ['Next'], {
				onclick() {
					buildQuestion.classList.replace('characteristics', 'characteristics-step-two')
					document.querySelector('.explanatory-text').innerHTML = 'As you fill out the <strong>PICO</strong> form, DocAnalytics will update the suggestions with relevant terms based on your previous selections.'
					return
				}
			}),
		]),
		QuestionArrow,
	])
export const OpeningDialog = Explanation.with(
	'.initial-explanation',
	{
		attached() {
			document.addEventListener('keydown', function (e) {
				if (e.keyCode == 27) {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					return
				}
			})
			buildQuestion.classList.add('welcome-styling')
		},
	},
	[
		Div('.top-container', [
			Div('.header', [
				H2('Welcome to DocAnalytics!'),
				A('.close', [' '], {
					onclick() {
						quitAutoPromptTourNoUser('dashboardStatisticsTour')
						quitAutoPromptTour('DashboardStatistics')
						buildQuestion.classList.remove('welcome-styling')
						removeContents()
						return
					},
				}),
			]),
			Div(
				'.explanatory-text',
				[
					P(
						'Start your query using the PICO builder, search bar, or by clicking on one of the example questions.'
					),
				],
				{
					ready() {
						faqOrReadOnly.valueOf()
							? (this.textContent =
									'Welome to DocAnalytics! Start your query using the example questions.')
							: null
					},
				}
			),
		]),
		Div('.bottom-container', [
			Button('.cancel.primary', ['Build a Question'], {
				onclick() {
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					showingExplanation.put(1)
					event.stopPropagation()
					event.preventDefault()
					return
				},
				ready() {
					faqOrReadOnly.valueOf() ? (this.hidden = true) : null
				},
				attached() {
					!document.querySelector('.dashboard-statistics')
						? this.classList.remove('hidden')
						: this.classList.add('hidden')
				},
			}),
			Button('.cancel.primary', ['Example Questions'], {
				onclick() {
					if (activeTab.valueOf() !== 'examples') {
						document.querySelector('#examples').classList.add('add-glow-animation-to-button')
					}
					setTimeout(() => {
						if (!document.querySelector('#examples').className.includes('current-tab'))
							document
								.querySelector('#examples')
								.classList.remove('add-glow-animation-to-button')
					}, 2000)

					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					showingExplanation.put(2)
					event.stopPropagation()
					event.preventDefault()
					return
				},
			}),
			Button('.cancel.primary', ['Enter a Query'], {
				onclick() {
					buildQuestion.classList.remove('welcome-styling')
					removeContents()
					showingExplanation.put(3)
					event.stopPropagation()
					event.preventDefault()
					return
				},
				ready() {
					faqOrReadOnly.valueOf() ? (this.hidden = true) : null
				},
			}),
		], {
			ready() {
				faqOrReadOnly.valueOf()
					&& (this.classList =
							'bottom-container flex-end')
			},
		}),
	]
)

export const ExampleQuestions = Explanation.with(
	'.filter-explanation',
	{
		attached() {
			document.addEventListener('keydown', function (e) {
				if (e.keyCode === 27) {
					quitAutoPromptTourNoUser('dashboardStatisticsTour')
					quitAutoPromptTour('DashboardStatistics')
					if (document.querySelector('.ask-question'))
								buildQuestion.classList.remove('dashboard-statistics-filter-pane-explanation')
					removeContents()
					return
				}
			})
			buildQuestion.classList.add('dashboard-statistics-filter-pane-explanation')
		},
	},
	[
		Div('.top-container', [
			Div('.header', [
				H2('Example Questions'),
				A('.close', [' '], {
					onclick() {
						quitAutoPromptTourNoUser('dashboardStatisticsTour')
						quitAutoPromptTour('DashboardStatistics')
						buildQuestion.classList.remove('dashboard-statistics-filter-pane-explanation')
						removeContents()
						return
					},
				}),
			]),
			Div(
				'.explanatory-text',
				{
					ready() {
						if (!document.querySelector('#examples').className.includes('active')) {
							this.append(
								P(`Click the Examples tab to open one of the example questions. Once you have run your own queries, you can find your recent and favorited searches here. `)
							)
						} else {
							this.append(
								 P(`You can select one of the example questions. Once you have run your own queries, you can find your recent and favorited searches here. `)
							)
						}
					},
				},
				[]
			),
		]),
		Div('.bottom-container.flex-end', [
			Button('.back2.primary', ['Back to welcome dialog'], {
				onclick() {
					buildQuestion.classList.remove('dashboard-statistics-filter-pane-explanation')
					removeContents()
					showingExplanation.put(0)
					event.stopPropagation()
					event.preventDefault()
				},
			}),
			QuestionArrow,
		]),
	]
)

export const background = Div('.blanket')

export const explanations = [
	{
		target: '.ask-question',
		element: OpeningDialog,
	},
	{
		target: '.demographics',
		element: FilterExplanation,
	},
	{
		target: '.available-questions-pane',
		element: ExampleQuestions
	},
	{
		target: '.analysis-selection',
		element: QuestionExplanation
	},
]

export const AnalysisExplanation = Explanation.with('.analysis-explanation', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('articlesTour')
				quitAutoPromptTour('Articles')
				removeContents()
				document.querySelector('.search-results').classList.remove('analysis')
				document.querySelector('.search-results').classList.remove('analysis-step-two')
				return
			}
		})
		document.querySelector('.search-results').classList.add('analysis')
		const node = document.querySelector('.run-analysis')
		node.addEventListener('click', function() {
				document.querySelector('.search-results').classList.remove('analysis')
			})
	}
}, [ 
	Div('.top-container', [
		Div('.header', [
			H2('Analysis'),
				A('.close', [' '],
				{
					onclick() {
						quitAutoPromptTourNoUser('articlesTour')
						quitAutoPromptTour('Articles')
						removeContents()
						document.querySelector('.search-results').classList.remove('analysis')
						document.querySelector('.search-results').classList.remove('analysis-step-two')
						return
					}
				}
				),
			]),
			Div('.explanatory-text', ['Click here to run analysis on the selected studies.']),
		]),
		Div('.bottom-container', [
			Div('.help-section', [
				Button('.learn.primary', ['Learn More'],
				{
					onclick() {
						setTimeout(() => {
							document.querySelector('.analysis-explanation').children[0].innerHTML = 'Select the desired analysis type from the drop-down and click here to run analysis on the selected studies. '
						}, 500)
						document.querySelector('.search-results').classList.replace('analysis', 'analysis-step-two')
						return
					}
				}),
				Icon('.link-confluence', {
					icon: helpIcon,
					title: 'Help',
					onclick() {
						window.open('https://confluence.doctorevidence.com/display/shareit/67502219/UKG3a90d27c63b6445fb047d571e32948f2EFQ')
					}
				}),
			]),
			Div('.action-section', [
				Button('.back.secondary', ['Back'],
				{
					onclick() {
						document.querySelector('.analysis-explanation').children[0].textContent = 'Review studies with available data by clicking the checkbox. Studies with available data are noted on the right with either of these icons:'
						document.querySelector('.search-results').classList.replace('analysis-step-two', 'analysis')
					}
				}
				),
				Button('.next.primary', ['Back'], {
					onclick() {
						removeContents()
						document.querySelector('.search-results').classList.remove('analysis')
						showingExplanation.put(showingExplanation.valueOf() - 1)
						event.stopPropagation()
						event.preventDefault()
					}
				}),
			])
		]),
		QuestionArrow,
	])

export const SearchDemographicExplanation = Explanation.with('.search-demographics-explanation', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('articlesTour')
				quitAutoPromptTour('Articles')
				removeContents()
				document.querySelector('.search-results').classList.remove('demographics-styling')
				return
			}
		})
		document.querySelector('.search-results').classList.add('demographics-styling')
	}
}, [
	Div('.top-container', [
		Div('.header', [
			H2(['Demographics & Study Characteristics']),
			A('.close', [' '],
			{
				onclick() {
					quitAutoPromptTourNoUser('articlesTour')
					quitAutoPromptTour('Articles')
					removeContents()
					document.querySelector('.search-results').classList.remove('demographics-styling')
					document.onclick = function(event) {
						return
					}
					return
				}
			}),
		]),
		Div('.explanatory-text', ['See the demographics and study characteristics of selected studies.']),
	]),
	Div('.bottom-container', [
		Div('.help-section', [
			Icon('.link-confluence', {
				icon: helpIcon,
				title: 'Help',
				onclick() {
					window.open('https://confluence.doctorevidence.com/display/shareit/67502442/WND4f20afc9c3bf4a8490d85c1d84ffc7daGID')
				}
			}),
		]),
		Div('.action-section', [
			Button('.next.secondary', ['Back'], {
				onclick() {
					removeContents()
					document.querySelector('.search-results').classList.remove('demographics-styling')
					showingExplanation.put(faqOrReadOnly.valueOf() ? 0 : showingExplanation.valueOf() - 1)
					event.stopPropagation()
					event.preventDefault()
				},
			}),
			Button('.next.primary', ['Next'], {
				onclick() {
					removeContents()
					document.querySelector('.search-results').classList.remove('demographics-styling')
					showingExplanation.put(showingExplanation.valueOf() + 1)
					event.stopPropagation()
					event.preventDefault()
				}
			}),
		]),
	]),
	QuestionArrow,
	])
export const ExtractIconsExplanation = Explanation.with('.articles-explanation', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('articlesTour')
				quitAutoPromptTour('Articles')
				resetSearchResults()
				removeContents()
				document.querySelector('.search-results').classList.remove('articles')
				return
			}
		})
		document.querySelector('.search-results').classList.add('articles-step-two')
		document.querySelector('.explanatory-text').append(
			new Div('.top-container', [
				Div('.header', [H2('Article Icons'), A('.close', [' '],
				{
					onclick() {
						quitAutoPromptTourNoUser('articlesTour')
						quitAutoPromptTour('Articles')
						resetSearchResults()
						removeContents()
						document.querySelector('.search-results').classList.remove('articles')
						return
					}
				}
				)]),
				Div('.explanatory-text', [
					Div('.viewAbstract-explanation-title', [
						P('These symbols let you know the publication type and status.'), P('You can click the status icon to see the article\'s abstract and access links to the full text.'),
					]),
					Div('.viewAbstract-explanation', [
						H3([
							Icon('.viewAbstract-explanation-icon', {
								icon: viewAbstract,
							}),
							'- Studies with pre-configured data.']),
					P('Click to view the abstract and links to full text.',)
					]),
					Div('.viewAbstract-explanation', [
						H3([
							Icon('.viewAbstract-explanation-icon', {
								icon: editExtract,
							}),
						,'- Studies extracted by your organization.']),
					P('Click to view the abstract, data extraction, and links to full text.'),
					]),
					Div('.viewAbstract-explanation', [
						H3([
							Icon('.viewAbstract-explanation-icon', {
								icon: addExtract,
							}),
						,'- Studies that have not been extracted yet.']),
					P('  Journal articles without available data. Click to view the abstract, extraction form, and links to full text.'),
					]),
				]),
			])
		)
		document.querySelector('.explanatory-text-two').append(new P('Click on'), new Icon({icon: editExtract}, ['or']), new Icon({icon: addExtract}, ['to continue the extract tour. You may need to scroll through the study list.']),)
	}
}, [
		Div('.explanatory-text', []),
		Div('.explanatory-text-two', []),
		Div('.bottom-container', [
			Div('.help-section', [
				Icon('.link-confluence', {
					icon: helpIcon,
					title: 'Help',
					onclick() {
						window.open('https://confluence.doctorevidence.com/display/shareit/67502217/KQI66c55447d30b4a269c6b13ff583df466WMY')
					}
				})
			]),
			Div('.action-section', [
				Button('.next.secondary', ['Back'],
				{
					onclick() {
						removeContents()
						document.querySelector('.search-results').classList.remove('articles-step-two')
						document.querySelector('.search-results').classList.add('back-from-extract-explanation')
						showingExplanation.put(showingExplanation.valueOf() - 1)
						setTimeout(() => {
							document.querySelector('.search-results').classList.replace('articles-expand-all', 'articles-step-three')
						}, 100)
					}
				}
				),
				Button('.next.primary', ['Next'],
				{
					onclick() {
						removeContents()
						document.querySelector('.search-results').classList.remove('articles-step-two')
						showingExplanation.put(showingExplanation.valueOf() + 1)
						event.stopPropagation()
						event.preventDefault()
					}
				}
				)
			]),
			QuestionArrow,
		])
	])

export const ArticleListExplanation = Explanation.with(
	'.articles-explanation',
	{
		ready() {
			faqOrReadOnly.valueOf() ? this.classList.add('articles-explanation-readonly') : null
		},
		attached() {
			let page = document.querySelector('.search-results')
			let studyList = page.querySelector('.study-list')
			if (page && page.classList.contains('back-from-extract-explanation')) {
				page.classList.remove('back-from-extract-explanation')
			} else {
				studyList.expandAll(true)
				setTimeout(() => {
					studyList.expandAll(false)
				}, 3000)
			}
			document.addEventListener('keydown', function (e) {
				if (e.keyCode == 27) {
					quitAutoPromptTourNoUser('articlesTour')
					quitAutoPromptTour('Articles')
					resetSearchResults()
					removeContents()
					return
				}
			})

			page.classList.add('articles-expand-all')
		},
	},
	[
		Div('.top-container', [
			Div('.header', [
				H2('Studies'),
				A('.close', [' '], {
					onclick() {
						quitAutoPromptTourNoUser('articlesTour')
						quitAutoPromptTour('Articles')
						resetSearchResults()
						removeContents()
					},
				}),
			]),
			Div(
				'.explanatory-text',
				Div(
					'.article-text-content',
					[
						'Click this arrow',
						Span('.icon-content', { content: '➤' }),
						'to expand (and collapse) all the studies that have available data, and see their reported results. You can also expand and collapse individual studies.',
					],
					{
						ready() {
							if(faqOrReadOnly.valueOf()) {
								this.innerHTML =
									'View the studies that have been found and selected for analysis, and click on studies to expand and see their individual results.'
							}
						},
					}
				)
			),
		]),
		Div('.bottom-container', [
			Div('.help-section', [
				Icon('.link-confluence', {
					icon: helpIcon,
					title: 'Help',
					onclick() {
						window.open(
							'https://confluence.doctorevidence.com/display/shareit/67502450/LII7a1f5ede052647f39468233e3180752eHLW'
						)
					},
				}),
			]),
			QuestionArrow,
			Div('.action-section', [
				Button('.back-to-expand-all.secondary', ['Back'], {
					onclick() {
						document.querySelector('.article-text-content').innerHTML =
							'<p>Click this arrow</p><span class="icon-content">➤</span><p>to expand and collapse all the studies that have available data, and see their reported results. You can also expand and collapse individual studies.</p>'
						document
							.querySelector('.search-results')
							.classList.replace('articles-check-all', 'articles-expand-all')
					},
				}),
				Button('.back-to-check-all.secondary', ['Back'], {
					onclick() {
						document.querySelector('.article-text-content').innerHTML =
							'<p>Click on this box <span>☐</span> to select every study eligible for analysis. Check marks will indicate if the selected study can be used for an analysis. Studies can still be selected if they are not able to be used for analysis.</p>'
						document
							.querySelector('.search-results')
							.classList.replace('articles', 'articles-check-all')
						document.querySelector('.studies-container .study-N').classList.remove('glow')
						document.querySelector('.studies-container .study-year').classList.remove('glow')
					},
				}),
				Button('.back-to-one.secondary', ['Back'], {
					onclick() {
						document.querySelector('.article-text-content').textContent =
							'Review studies with available data by clicking the checkbox. Studies with available data are noted with one of these symbols.'
						document
							.querySelector('.article-text-content')
							.append(
								new Div('.icon-container', [
									new Icon('.extract', { icon: viewAbstract }),
									new Icon('.extract', { icon: editExtract }),
								])
							)
						document
							.querySelector('.search-results')
							.classList.replace('articles-name-slider', 'articles')
					},
				}),
				Button('.back-n-slider.secondary', ['Back'], {
					onclick() {
						if (document.querySelector('.articles-n-slider') != null) {
							document.querySelector(
								'.article-text-content'
							).textContent = `Studies are automatically sorted by a combination of best match and data available for analysis. Click where you see the `
							document
								.querySelector('.article-text-content')
								.append(
									new Icon('.sort-icon', { icon: sortIcon }),
									new Div('', { style: 'display: inline' }, [
										' symbol 	to sort by most recent, total population N, best match, or most analyzable.',
									])
								)
							document
								.querySelector('.search-results')
								.classList.replace('articles-n-slider', 'articles-name-slider')
						}
					},
				}),
				Button('.back-to-step-two.secondary', ['Back'], {
					onclick() {
						if (document.querySelector('.articles-step-three') != null) {
							document.querySelector(
								'.article-text-content'
							).textContent = `Studies are automatically sorted by a combination of best match and data available for analysis. Click where you see the `
							document
								.querySelector('.article-text-content')
								.append(
									new Icon('', { icon: sortIcon }),
									new Div('', { style: 'display: inline' }, [
										' symbol to sort by most recent, total population N, best match, or most analyzable.',
									])
								)
							document
								.querySelector('.search-results')
								.classList.replace('articles-step-three', 'articles-name-slider')
							document.querySelector('.studies-container .study-year').classList.add('glow')
							document.querySelector('.studies-container .study-N').classList.add('glow')
						}
					},
				}),
				Button('.primary.stylish-expand-all', ['Next'], {
					onclick() {
						document
							.querySelector('.search-results')
							.classList.replace('articles-expand-all', 'articles-check-all')
						document.querySelector('.article-text-content').innerHTML =
							'<p>Click this box<span class="icon-content">☐</span>to select and view the studies suggested for analysis. Review data and treatment assignments, adjusting or deselecting as necessary.</p>'
					},
				}),
				Button('.learn.primary', ['Next'], {
					onclick() {
						document
							.querySelector('.search-results')
							.classList.replace('articles', 'articles-check-all')
						document.querySelector('.article-text-content').innerHTML =
							'<p>Click this box<span class="icon-content square">☐</span> to select and view the studies suggested for analysis. Review data and treatment assignments, adjusting or deselecting as necessary.</p>'
					},
				}),
				Button('.learn-one.primary', ['Next'], {
					onclick() {
						if (faqOrReadOnly.valueOf()) {
							resetSearchResults()
							removeContents()
							showingExplanation.put(2)
							return
						}
						document
							.querySelector('.search-results')
							.classList.replace('articles-check-all', 'articles')
						document.querySelector('.explanatory-text').textContent = ``
						document
							.querySelector('.explanatory-text')
							.append(
								new Div('.article-text-content', [
									'Review studies with available data by clicking the checkbox. Studies with available data are noted with one of these symbols: \r\n',
									Div('.icon-container', [
										Icon('.extract', { icon: viewAbstract }),
										Icon('.extract', { icon: editExtract }),
									]),
								])
							)
						document
							.querySelector('.articles-explanation')
							.classList.add('middle-position')
					},
				}),
				Button('.learn-three.primary', ['Learn More'], {
					onclick() {
						document
							.querySelector('.search-results')
							.classList.replace('articles-step-two', 'articles-step-three')
					},
				}),
				Button('.learn-select-all.primary', ['Next'], {
					onclick() {
						document.querySelector(
							'.article-text-content'
						).textContent = `Studies are automatically sorted by a combination of best match and data available for analysis. Click where you see the `
						document
							.querySelector('.article-text-content')
							.append(
								new Icon('.extract', { style: 'display: inline', icon: sortIcon }),
								new Div('', { style: 'display: inline' }, [
									' symbol to sort by most recent, total population N, best match, or most analyzable.',
								])
							)
						document
							.querySelector('.search-results')
							.classList.replace('articles', 'articles-name-slider')
						document.querySelector('.studies-container .study-year').classList.add('glow')
						document.querySelector('.studies-container .study-N').classList.add('glow')
					},
				}),
				Button('.learn-name-slider.primary', ['Next'], {
					onclick() {
						document.querySelector(
							'.article-text-content'
						).textContent = `If multiple publications are associated with a study, they will be grouped together. Open the drop-down to change the publication selected for analysis.`
						document
							.querySelector('.search-results')
							.classList.replace('articles-name-slider', 'articles-step-three')
						document.querySelector('.studies-container .study-N').classList.remove('glow')
						document.querySelector('.studies-container .study-year').classList.remove('glow')
					},
				}),
				Button('.next.primary', ['Next'], {
					onclick() {
						resetSearchResults()
						removeContents()
						showingExplanation.put(showingExplanation.valueOf() + 1)
						event.stopPropagation()
						event.preventDefault()
					},
				}),
			]),
		]),
	]
)

export const extractExplanation = Explanation.with('.extract-explanation', {
	ready() {
		if (document.querySelector('.submit-extraction') && app.user.Settings.Tour.Extract) {
			this.remove()
		}
		else if (!document.querySelector('.submit-extraction') && app.user.Settings.Tour.ExtractAnnotate) {
			this.remove()
		}
	},
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('extractTour')
				quitAutoPromptTour('Extract')
				quitAutoPromptTourNoUser('extractAnnotateTour')
				quitAutoPromptTour('ExtractAnnotate')
				resetSearchResults()
				removeContents()
				document.querySelectorAll('.extract-explanation').forEach(item => {item.remove()})
				document.querySelector('.modal-dialog').classList.remove('demographics-styling')
				return
			}
		})
		if (!document.querySelector('.search-results').classList.contains('hide-next'))
			resetSearchResults()
		document.querySelector('.search-results').classList.add('extract-explanation-styling')
		blanket.remove()
	}
}, [
	Div('.top-container', [
		Div('.header', [
			H2('Rapid Extraction'),
			A('.close', [' '],
			{
				onclick() {
					quitAutoPromptTourNoUser('extractAnnotateTour')
					quitAutoPromptTour('ExtractAnnotate')
					quitAutoPromptTourNoUser('extractTour')
					quitAutoPromptTour('Extract')
					resetSearchResults()
					removeContents()
					document.querySelectorAll('.extract-explanation').forEach(item => {item.remove()})
					document.querySelector('.modal-dialog').classList.remove('demographics-styling')
					return
				}
			}),
		]),
			Div('.explanatory-text', ['Review the suggested information and determine what needs to be added or updated.']),
		]),
		Div('.bottom-container', [
			Div('.help-section', [
				Icon('.link-confluence', {
					icon: helpIcon,
					title: 'Help',
					onclick() {
						window.open('https://confluence.doctorevidence.com/display/shareit/67502217/KQI66c55447d30b4a269c6b13ff583df466WMY')
					}
				}),
			]),
			Div('.action-section', [
				Button('.back-two.secondary', ['Back'],
				{
					onclick() {
						document.querySelector('.search-results').classList.replace('extract-explanation-styling-two', 'extract-explanation-styling')
						document.querySelector('.explanatory-text').textContent = 'Review the auto-extracted information and determine what needs to be added or updated.'
						return
					}
				}),
				Button('.back-three.primary', ['Back'],
				{
					onclick() {
						document.querySelector('.search-results').classList.replace('extract-explanation-styling-three', 'extract-explanation-styling-two')
						document.querySelector('.explanatory-text').textContent = 'Input data by typing into the fields or by clicking from the field to the desired highlighted value in the abstract.'
						return
					}
				}),
				Button('.back-four.secondary', ['Back'],
				{
					onclick() {
						let element = document.querySelector('.extract-explanation')
						element.style.removeProperty('left')
						element.style.removeProperty('top')
						document.querySelector('.search-results').classList.replace('extract-explanation-styling-four', 'extract-explanation-styling-three')
						document.querySelector('.explanatory-text').textContent = `The data of interest may not be present in the abstract. Click one of the links to open the full text, adding the desired values by typing into the extraction fields.`
						return
					}
				}),
				Button('.back-five.secondary', ['Back'],
				{
					onclick() {
						document.querySelector('.search-results').classList.replace('extract-explanation-styling-five', 'extract-explanation-styling-four')
						document.querySelector('.explanatory-text').textContent = `When complete, click 'Submit Extraction'`
						return
					}
				}),
				Button('.learn-two.primary', ['Next'],
				{
					onclick() {
						document.querySelector('.search-results').classList.replace('extract-explanation-styling', 'extract-explanation-styling-two')
						document.querySelector('.explanatory-text').textContent = 'Input data by typing into the fields or by clicking from the field to the desired highlighted value in the abstract.'
						return
					}
				}),
				Button('.learn-three.primary', ['Next'],
				{
					onclick() {
						document.querySelector('.search-results').classList.replace('extract-explanation-styling-two', 'extract-explanation-styling-three')
						document.querySelector('.explanatory-text').textContent = 'The data of interest may not be present in the abstract. Click one of the links to open the full text, adding the desired values by typing into the extraction fields.'
						let button = null
						let rect = document.querySelectorAll('.submit-extraction')
						rect.forEach(buttons => {
							let pos = cumulativeOffset(buttons)
							if (pos.top != 0 && pos.left != 0) {
								button = buttons
							}
						})
						let res = cumulativeOffset(button)
						if (button == null) {
							document.querySelector('.learn-four.primary').classList.add('hidden')
						}
						else {
							document.querySelector('.learn-four.primary').classList.remove('hidden')
						}
						return
					}
				}),
				Button('.learn-four.primary', ['Next'],
				{
					onclick() {
						let button = null
						let top, left
						let rect = document.querySelectorAll('.submit-extraction')
						rect.forEach(buttons => {
							let pos = cumulativeOffset(buttons)
							if (pos.top != 0 && pos.left != 0) {
								button = buttons
								top = pos.top
								left = pos.left
							}
						})
						if (button == null)
							this.classList.add('hidden')
						else {
							let element = document.querySelector('.extract-explanation')
							document.querySelector('.search-results').classList.replace('extract-explanation-styling-three', 'extract-explanation-styling-four')
							element.style.top = (top + 50) + 'px'
							element.style.left = (left - 150) + 'px'
							document.querySelector('.explanatory-text').textContent = `When complete, click 'Submit Extraction'`
							return
						}
					}
				}),
			])
		])
		])
		var cumulativeOffset = function(element) {
			if (element == null)
				return
			var top = 0, left = 0;
			do {
				top += element.offsetTop  || 0;
				left += element.offsetLeft || 0;
				element = element.offsetParent;
			} while(element);
		
			return {
				top: top,
				left: left
			};
		};
export const FilterPaneExplanation = Explanation.with('.filter-explanation', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('articlesTour')
				quitAutoPromptTour('Articles')
				removeContents()
				document.querySelector('.search-results').classList.remove('filter-pane-explanation')
				return
			}
		})
		document.querySelector('.search-results').classList.add('filter-pane-explanation')
		document.querySelector('.explanatory-text').innerHTML = faqOrReadOnly.valueOf()
			? 'Use the filter panel to view the <strong>Conditions</strong>, <strong>Treatments</strong>, and <strong>Outcomes</strong> for analysis.'
			: 'Use the filter panel to adjust the <strong>Conditions</strong>, <strong>Treatments</strong>, and <strong>Outcomes</strong> for analysis.<br><br> If you want to include multiple treatments as the intervention or comparator, click the box next to the treatment to assign a common treatment name. <br><br>Additionally, use the <strong>Study</strong> filters to specify study design and publication date.'
	}
}, [
	Div('.top-container', [
		Div('.header', [
			H2('Filter Panel'),
			A('.close', [' '],
				{
					onclick() {
						quitAutoPromptTourNoUser('articlesTour')
						quitAutoPromptTour('Articles')
						removeContents()
						document.querySelector('.search-results').classList.remove('filter-pane-explanation')
						return
					}
				}
			),
		]),
	Div('.explanatory-text', []),
	]),
	Div('.bottom-container', [
		Div('.help-section', [
			Icon('.link-confluence', {
				icon: helpIcon,
				title: 'Help',
				onclick() {
					window.open('https://confluence.doctorevidence.com/display/shareit/67502442/WND4f20afc9c3bf4a8490d85c1d84ffc7daGID')
				}
			}),
		]),
		Div('.action-section', [
			Button('.back.secondary', ['Back'],
			{
				onclick() {
					document.querySelector('.analysis-explanation').children[0].textContent = 'Open and review other studies with available data by clicking the checkbox, author/study name, or title. Studies with available data are noted with one of these symbols '
					document.querySelector('.search-results').classList.replace('analysis-step-two', 'analysis')
				}
			}
			),
			Button('.next.secondary', ['Back'],
			{
				onclick() {
					removeContents()
					document.querySelector('.search-results').classList.remove('filter-pane-explanation')
					showingExplanation.put(showingExplanation.valueOf() - 1)
					event.stopPropagation()
					event.preventDefault()
				}
			}
			),
			Button('.next.primary', ['Next'],
				{
					onclick() {
						removeContents()
						document.querySelector('.search-results').classList.remove('filter-pane-explanation')
						showingExplanation.put(showingExplanation.valueOf() + 1)
						event.stopPropagation()
						event.preventDefault()
					}
				}
				),

		])
	]),
		QuestionArrow,
	])

export const ReportExplanation = Explanation.with('.report-explanation', {
	attached() {
		document.addEventListener('keydown', function(e) {
			if (e.keyCode == 27) {
				quitAutoPromptTourNoUser('metaReportTour')
				quitAutoPromptTour('MetaReport')
				removeContents()
				document.querySelector('.search-results').classList.remove('report-styling')
				return
			}
		})
		document.querySelector('.search-results').classList.add('report-styling')

		const node = document.querySelector('.meta-analysis')
		node.addEventListener('click', function(event) {
			quitAutoPromptTourNoUser('metaReportTour')
			quitAutoPromptTour('MetaReport')
			document.querySelector('.search-results').classList.remove('report-styling')
			removeContents()
		})
	}
}, [
		A('.close', [' '],
			{
				onclick() {
					quitAutoPromptTourNoUser('metaReportTour')
					quitAutoPromptTour('MetaReport')
					removeContents()
					document.querySelector('.search-results').classList.remove('report-styling')
					return
				}
			}),
		Div('.explanatory-text', ['Click to view a downloadable report on your analysis including results, normalized study data, citations, and several data visualizations. ']),
		QuestionArrow,
	])

//remove compontents from screen
export function removeContents() {
	document.querySelector('.search-results') ? document.querySelector('.search-results').classList.remove('hide-next') : null
	document.querySelectorAll('.welcome-explanation').forEach(item => {item.remove()})
	document.querySelectorAll('.blanket').forEach(item => {item.remove()})
	document.querySelector('.landing-footer')?.remove()
	document.querySelector('.available-questions')?.remove()
	document.querySelector('.spacer')?.remove()
}
//remove next button when user specifies individual component from DD
function hideButton() {
	document.querySelector('.search-results').classList.add('hide-next')
}
//remove stying for components
function resetSearchResults() {
	document.querySelector('.search-results').className = 'search-results'
}
//Tour will not initally appear if user selects exit
async function quitAutoPromptTour(page) {
	let user = await app.user
	let history = user?.Settings?.Tour || {DashboardStatistics: false, Articles: false, MetaReport: false, Extract: false, QuestionEditing: false}
	if (!history[page] && user) {
		history[page] = true
		patch<User>('/portal/User/'+app.user.Id, {
			data: {
				Settings: {
					Tour: history 
				}
			}
		})
	}
}
function quitAutoPromptTourNoUser(page) {
	localStorage.setItem(page, 'hide')
}

export const explanations2 = [
	{
		target: '.studies-container',
		element: ArticleListExplanation
	},
	{
		target: '.studies-pane',
		element: ExtractIconsExplanation
	},
	{
		target: '.demographics',
		element: SearchDemographicExplanation
	},
	{
		target: '.filter-pane',
		element: FilterPaneExplanation
	},
	{
		target: '.analysis-selection',
		element: AnalysisExplanation
	},
	{
		target: '.extract-dialog',
		element: extractExplanation
	},
	{
		target: '.analysis-selection',
		element: ReportExplanation
	},
	{
		target: '.analysis-selection',
		element: QuestionExplanation
	}
]

const skipWelcomeExplanations = false
export async function startExplanations(start, bool, pageload, annotate, previousComponent?) {
	let user = await app.user
	if (!user)
		return
	let settings = app.user.Settings.Tour
	let history = settings || {DashboardStatistics: true, Articles: true, MetaReport: true, Extract: true, ExtractAnnotate: true, noAccount: true}
	//user has not seen tour before and does not have settings established
	if (settings == undefined) {
		patch<User>('/portal/User/'+app.user.Id, {
			data: {
				Settings: { Tour: {'DashboardStatistics': false, 'Articles': false, 'MetaReport': false , 'Extract': false, 'ExtractAnnotate': false, 'QuestionEditing': false },
			}}
		})
	}
	if (explanations2[start])
		track({ event: 'tour', explanation: explanations2[start].target.slice(1) })

	//always start from beginning of tour
	if (pageload == true && bool == false) {
		showingExplanation.put(0)
	}
	if (document.querySelector('.search-results') || document.querySelector('.waiting-for-results')) {
		if (skipWelcomeExplanations)
			return
		//if user specifies individual step in tour from DD or MetaReport shown to first time user
		if (bool) {
			removeContents()
			hideButton()
			if (start == 5 && !history.Extract || start == 5 && !history.ExtractAnnotate || localStorage.getItem('extractTour') != 'hide' && history.noAccount || localStorage.getItem('extractAnnotateTour') != 'hide' && history.noAccount) {
				setTimeout(() => {
					let explanation = explanations2[start]
					removeContents()
					document.querySelector(explanation.target).append(explanation.element)
					setTimeout(() => {
						if (!annotate) {
							hideButton()
							document.querySelector('.explanatory-text').textContent = `This study's data is pre-configured and cannot be extracted or edited. Click the links provided to view the original study.`
						}
					}, 1)
					document.querySelector('.blanket') ? null : document.querySelector('.search-results').append(blanket)
					return
				}, 1000)
			}
			if (start == 6 && !history.MetaReport || localStorage.getItem('metaReportTour') != 'hide' && history.noAccount) {
				let explanation = explanations2[start]
				document.querySelector(explanation.target).append(explanation.element)
				document.querySelector('.blanket') ? null : document.querySelector('.search-results').append(blanket)
			}
			else if (start != 6 && start != 5 || pageload == 'extract' || pageload == 'extract-article-entry') {
				let explanation = explanations2[start]
				if (pageload == 'extract-article-entry' || pageload == 'extract') {
					setTimeout(() => {
						removeContents()
						document.querySelector(explanation.target).append(explanation.element)
						setTimeout(() => {
							if (!annotate) {
								hideButton()
								document.querySelector('.explanatory-text').textContent = `This study's data is pre-configured and cannot be extracted or edited. Click the links provided to view the original study.`
							}
						}, 1)
						document.querySelector('.blanket') ? null : document.querySelector('.search-results').append(blanket)
						return
					}, 500)
				}
				else {
					start == 7 ? document.querySelector(explanation.target).append(explanation.element({searchBar: previousComponent})) :
						document.querySelector(explanation.target).append(explanation.element)
						if (start !== 7 )
							document.querySelector('.blanket') ? null : document.querySelector('.search-results').append(blanket)
					
				}
			}
			return
		}
		showingExplanation.subscribe(async (event) => {
			let k = bool ? start : event.value()
			let explanation = explanations2[k]
			let user = await app.user
			let history = user?.Settings.Tour || {DashboardStatistics: true, Articles: true, MetaReport: true, Extract: true, ExtractAnnotate: true, noAccount: true}
			if (k > 4) {
				k = 0
				if (!history.Articles) {
					history.Articles = true
					let results = await patch('/portal/User/' + app.user.Id, {  data: { Settings: {Tour: history } } })
					history = results.Tour
				}
				return
			}
			let r = document.querySelector('.welcome-explanation')
			if (r != null) {
				return
			}
			removeContents()
			if (!history.Articles || !pageload && !bool || localStorage.getItem('articlesTour') != 'hide' && history.noAccount) {
				document.querySelector(explanation.target).append(explanation.element)
				document.querySelector('.blanket') ? null : document.querySelector('.search-results').append(blanket)
			}
		})
	} else if (buildQuestion.classList.contains('ask-question')) {
		//UPDATE - Can we get rid of the below commented code? --------
		//revert to first time user -- testing purposes
		/*
		patch<User>('/portal/User/'+app.user.Id, {
			data: {
				Settings: {'DashboardStatistics': false, 'Articles': false, 'MetaReport': false , 'Extract': false, 'ExtractAnnotate': false, 'QuestionEditing': false },
			}
		}).then(results => {
			console.log(results)
		})
		*/
		if (skipWelcomeExplanations)
			return
		showingExplanation.subscribe(async (event) => {
			let user = await app.user
			let QuestionEditing = app.user.Settings?.Tour?.QuestionEditing || false
			let history = user?.Settings.Tour || {Dashboard: true, Articles: true, MetaReport: true, Extract: true, noAccount: true}

			if (!buildQuestion.classList.contains('ask-question'))
				return
			if (start == 7) {
				let r = document.querySelector('.welcome-explanation')
				if (r != null) {
					return
				}
				if (!QuestionEditing) {
					let explanation = explanations[3]
					if (!explanation)
						return // if it doesn't exist, don't continue
					document.querySelector(explanation.target).append(explanation.element({searchBar: previousComponent}))
					return
				}
			}	
			if (buildQuestion.classList.contains('ask-question')) {
				//stop loop from continuing if component is mounted
				let r = document.querySelector('.welcome-explanation')
				if (r != null) {
					return
				}
				if (!history.DashboardStatistics || !pageload || localStorage.getItem('dashboardStatisticsTour') != 'hide' && history.noAccount) {
					let explanation = explanations[event.value()]
					if (!explanation)
						return // if it doesn't exist, don't continue
					document.querySelector('.blanket') ? null : buildQuestion.append(blanket)
					document.querySelector(explanation.target).append(explanation.element)
				}
			}
		})
	}
}
